import { ApiLambdalerAuthHeaderSchema } from '@eigtech/lambdaler-api-gateway-types';
import { CornSchema } from '@eigtech/shared-corn';
import { z } from 'zod';
export const ListUnmergedVideosApiSchema = {
    headers: ApiLambdalerAuthHeaderSchema.required({ requestActor: true }),
    params: z.object({
        entityId: CornSchema,
        startTime: z.string().datetime(),
    }),
    response: z.object({
        files: z
            .object({
            filename: z.string(),
        })
            .array(),
        message: z.string().optional(),
    }),
};
export const ListUnmergedVideosRequestSchema = ListUnmergedVideosApiSchema.headers.merge(ListUnmergedVideosApiSchema.params);
export const ListUnmergedVideosResponseSchema = ListUnmergedVideosApiSchema.response;
